<template>
    <v-row>
        <v-col cols="12">
            <div class="headline">Agendas</div>
            <v-progress-linear indeterminate v-if="loading" aria-label="Loading"></v-progress-linear>
            <v-list>
                <v-list-item v-for="i in UniqueDates" :key="i">
                    <v-btn block rel="noopener" :href="combindAgendaURL(i)">Committee Agendas for {{MinDatePretty(i)}}</v-btn>
                </v-list-item>
            </v-list>
        </v-col>
    </v-row>
</template>
<script>
    import moment from 'moment'

    export default {
        name: 'CombinedAgendas',
        props: ['CommitteeId'],
        components: {

        },
        methods: {
            switchTab(item)
            {
                this.filterValue = item.value;
            },
            LoadData()
            {
                this.loading = true;
                if (this.currentRoute.includes('/Interim'))
                {

                }
                else
                {
                    fetch('/api/SessionCommittees/CommitteeAgendas/' + this.CommitteeId,
                        {
                            method: "GET",
                            credentials: "include",
                            headers: { "Content-Type": "application/json" },
                        })
                        .then(res =>
                        {
                            this.loading = false;

                            if (res.ok)
                            {
                                return res.json();
                            }
                            else
                            {
                                return res.text().then(r => Promise.reject(r));
                            }
                        })
                        .then(response =>
                        {
                            this.YearCommittee = EncodeDatetimes(response);
                            if (this.YearCommittee.CommitteeAgendas != null)
                            {
                                var dates = this.YearCommittee.CommitteeAgendas.map(z => moment(z.DocumentDate).format('MM/DD/YYYY')).reverse();
                                this.UniqueDates = [new Set(dates)][0];
                            }

                        }).catch(error =>
                        {
                            throw new Error(error);
                        });
                }
            },
            MinDatePretty(Date)
            {
                if (Date != undefined)
                {
                    return moment(Date).format('M/DD');
                }
                else
                {
                    return null;
                }
            },

            combindAgendaURL(item)
            {
                var docs = this.YearCommittee.CommitteeAgendas.filter(x => moment(x.DocumentDate).format('MM/DD/YYYY') == moment(item).format('MM/DD/YYYY'));
                var str = "";
                docs.forEach(i =>
                {
                    str += "&Ids=" + i.DocumentId;
                });
                str = str.substring(1, str.length);
                return this.$MyLRCUrl.value + 'api/Documents/Combined.pdf?' + str;
            }
        },
        data: function ()
        {
            return {
                loading: true,
                loadingHTML: true,
                filterValue: 'Detail',
                UniqueDates: [],
                HouseRulesURL: null,
                SenateRulesURL: null,
                JointRulesURL: null,
                SenateSeatingChartURL: null,
                HouseSeatingChartURL: null,
                HouseDirectoryURL: null,
                SenateDirectoryURL: null,
                tabs: [
                    {
                        value: 'Detail', type: 'All'
                    },
                    {
                        value: 'Agendas', type: 'All'
                    },
                    {
                        value: 'Minutes & Audio', type: 'All'
                    },
                    {
                        value: 'Bills', type: 'Session'
                    },
                    {
                        value: 'Hearing Documents', type: 'All'
                    },
                    {
                        value: 'Committee Agendas', type: 'Session'
                    },
                ],
                headers: [{ text: 'Date', value: 'DocumentDate' }, { text: '', value: 'DocumentId' }, { text: '', value: 'data-table-expand' },],
                billHeaders: [{ text: 'Bill', value: 'BillId' }, { text: 'Title', value: 'Title' },],
                expandedAgendas: [],
                expandedMinutes: [],
                CommitteeMemberTypes: [],
                YearCommittee: {
                    Session: {
                        Year: '',
                        SessionId: null,
                    },
                    Committee: {
                        MeetingTime: '',
                        Room: {
                            Room: '',
                        },
                        Days: '',
                    },
                },
                Documents: [],
            }
        },
        mounted: function ()
        {
            this.LoadData();
        },
        watch: {
            CommitteeId: function ()
            {
                this.LoadData();
            }
        },
        computed: {
            CommitteeType: function ()
            {
                //switching between session and interm
                if (this.currentRoute.includes('/Interim'))
                {
                    return "Interim";
                } else
                {
                    return "Session";
                }
            },
            currentRoute: function ()
            {
                return this.$route.path;
            },
            Agendas: function ()
            {
                var agendaDocTypeId = [3, 5];
                return this.YearCommittee.Documents.filter(x => agendaDocTypeId.includes(x.DocumentTypeId));
            },
            Minutes: function ()
            {
                var minDocTypeId = [2, 4];
                return this.YearCommittee.Documents.filter(x => minDocTypeId.includes(x.DocumentTypeId));
            },


        }
    };
</script>
<style></style>